export const PRESCRIPTION_IMAGE_SLIDE = 'PRESCRIPTION_IMAGE_SLIDE';
export const PRESCRIPTION_DELIVERY_VISIT = 'PRESCRIPTION_DELIVERY_VISIT';
export const DELIVERY_REQUEST_CANCEL_BUTTON = 'DELIVERY_REQUEST_CANCEL_BUTTON';
export const DELIVERY_REQUEST_CANCEL_MODAL_BUTTON =
  'DELIVERY_REQUEST_CANCEL_MODAL_BUTTON';
